import { z } from 'zod';

export const $UserFormCreteValidate = z
  .object({
    firstName: z.string().min(1, 'Имя обязательно для заполнения'),
    lastName: z.string().min(1, 'Фамилия обязательна для заполнения'),
    email: z.string().email('Некорректный email'),
    phone: z.string().optional().nullable(),
    role: z
      .string({ message: 'Группа обязательна для заполнения' })
      .min(1, 'Группа обязательна для заполнения'),
    companyId: z.string().optional().nullable(),
    password: z
      .string({ message: 'Заполните обязательное поле' })
      .min(8, { message: 'Пароль должен быть не менее 8 символов' })
      .max(64, { message: 'Пароль должен быть не более 64 символов' })
      .nullable(),
    passwordConfirmation: z
      .string({ message: 'Заполните обязательное поле' })
      .min(8, { message: 'Пароль должен быть не менее 8 символов' })
      .max(64, { message: 'Пароль должен быть не более 64 символов' })
      .nullable(),
  })
  .refine(data => data.password === data.passwordConfirmation, {
    message: 'Пароли не совпадают',
    path: ['passwordConfirmation'],
  });
export type UserFormCreateValidate = z.infer<typeof $UserFormCreteValidate>;

export type UserFormCreateValues = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: string;
  companyId?: string;
  password: string;
  passwordConfirmation: string;
};
